<template lang="pug">
</template>

<script>
import { serverDomain } from "@/config";
import Cookie from "@/utils/cookie.js";

export default {
  name: "Coupon",
  created() {
    if(this.$route.params.id) {
      let queryString = new URLSearchParams(this.$route.query).toString()
      Cookie.remove("__gfPromotion");

      window.location.href = `${serverDomain()}/coupons/${this.$route.params.id}?${queryString}`
    } else {
      this.$router.push({ name: "Error404" });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
